<div class="modal-header pt-1 mb-1">
  <h2 class="modal-title" id="modal-basic-title" translate>
    @if(service.cert?.type === 'instructor_certification') {
    <span translate>Certification details</span>
    }@else {
    <span translate>Meet your requirements</span>
    }
  </h2>
  <button class="btn-close btn-red" (click)="dismiss()"></button>
</div>
@if (service.cert) {
<div class="modal-body py-2">
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>ID</div>
    <div>{{ service.cert.id }}</div>
  </div>
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Start date</div>
    <div>{{ service.cert.certification_date | i18nDate : 'dd MMMM yyyy' }}</div>
  </div>
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Type</div>
    @if(service.cert?.type === 'kiteboarder_certification') {
    <div translate>Course</div>
    } @else {
    <div>{{ service.cert.type_1 }}</div>
    }
  </div>
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Training hours</div>
    <div>{{ service.cert.teaching_hours }}</div>
  </div>
  @if(service.cert?.type !== 'instructor_certification') {
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Course name</div>
    <div translate>{{ service.cert.course_title }}</div>
  </div>
  } @if(service.cert?.type === 'kiteboarder_certification') {
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Certified level</div>
    <div>{{ trainingLevels() }}</div>
  </div>
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Qualification</div>
    <div translate>Kiteboarder</div>
  </div>
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Qualification date</div>
    <div>{{ service.cert.certification_date | i18nDate : 'dd MMMM yyyy' }}</div>
  </div>
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Trained by</div>
    <a [routerLink]="['/members', service.cert.instructor_id] | localize">{{ service.cert.instructor_name }}</a>
  </div>
  }@else if(service.cert?.type === 'ecourse_certification'){
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Highest Score</div>
    <div>{{ service.highestScore }}%</div>
  </div>
  }@else {
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Course taken</div>
    <div>{{ service.cert.training_levels[0]?.title }}</div>
  </div>
  } @if(service.cert.school_id) {
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Location</div>
    <div>
      <span [innerHTML]="service.cert.school_country"></span>,
      <span [innerHTML]="service.cert.school_locality"></span>
    </div>
  </div>
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>School name</div>
    <a [routerLink]="['/centers', service.cert.school_id] | localize" [innerHTML]="service.cert.school_name"></a>
  </div>
  }
  <div class="info-item d-lg-flex">
    <div class="info-label" translate>Status</div>
    <div>{{ service.cert.status_1 }}</div>
  </div>
  <div class="info-item d-lg-flex">
    @if(!service.isLoading && service.recOrATCOrITC && !isProduction && !service.feedbackId) {
    <div class="info-label">
      <a class="btn btn-success my-1" (click)="openFeedback()" translate> Leave your feedback </a>
    </div>
    } @if(service.cert.status === 'passed') {
    <div>
      <a class="btn btn-success my-1" (click)="downloadCert()" translate>Download</a>
    </div>
    }
  </div>
  @if (service.requirements) {
  <div class="mt-3">
    <h3 class="mb-2" translate>Requirements</h3>
    @for (req of service.requirements; track req.plugin_id) {
    <div class="d-flex align-items-center mb-2">
      <i
        class="me-1 my-1 icon icon-32"
        [ngClass]="{ 'text-secondary icon-check-circle': req.result, 'text-danger icon-times-circle': !req.result }"
      ></i>
      <div [innerHTML]="req.description"></div>
    </div>
    }
  </div>
  } @if (service.extraTasks && service.extraTasks.length > 0) {
  <div class="mt-3">
    <h3 class="mb-2" translate>Extra tasks</h3>
    @for (comment of service.extraTasks; track comment.cid) {
    <div class="d-flex align-items-center mb-2">
      <i
        class="me-1 my-1 icon icon-32"
        [ngClass]="{
          'text-secondary icon-check-circle': comment.field_completed === '1',
          'text-danger icon-times-circle': comment.field_completed !== '1'
        }"
      ></i>
      <div [innerHTML]="comment.comment_body"></div>
    </div>
    }
  </div>
  } @if(service.isLoading) {
  <div class="text-center">
    <circular-spinner iconClass="icon-64 text-success"></circular-spinner>
  </div>
  }
</div>
}
